export const Options = [
  "this-week",
  "last-week",
  "this-month",
  "last-month",
];
